export default __webpack_public_path__ + "static/media/clock.80a4a95b.svg";